import React from 'react'
import { Box } from '@mui/material'

import Modal2 from '@/components/Modal2'

interface ReceiptModalProps {
  url: string
  open: boolean
  onCancel: () => void
}

const ReceiptModal: React.FC<ReceiptModalProps> = ({ open, onCancel, url }) => {
  return (
    <Modal2 title='对公回执单' width={800} showCancel={false} open={open} onCancel={onCancel} onOk={onCancel}>
      <Box component='img' sx={{ width: '100%' }} src={url} />
    </Modal2>
  )
}

export default ReceiptModal
